import { BaseEntity } from "./BaseEntity";
import { Category } from "./Category";
import { Department } from "./Department";
import { GhtGroup } from "./GhtGroup";
import { Region } from "./Region";

export class School extends BaseEntity {
    public name: string = "";
    public description?: string = "";
    public imageName?: string = "";
    public externalCode?: string = "";
    public siret?: string = "";
    public phone?: string = "";
    public address?: string = "";
    public zipCode?: string = "";
    public city?: string = "";
    public latitude?: string = "";
    public longitude?: string = "";
    public isActive?: boolean = false;
    public category?: string | Category = "";
    public region?: string | Region = "";
    public department?: string | Department = "";
    public ghtGroup?: string | GhtGroup = "";
    public finessCode?: string = "";

    // Blameable
    public createdBy?: string = "";
    public updatedBy?: string = "";

    constructor(model: Partial<School> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PSchool = Partial<School>;
